import Axios, { AxiosResponse } from 'axios';
import { config } from '../../../config';

// eslint-disable-next-line import/prefer-default-export
export const getNews = async (
  pageIndex?: number,
  pageSize?: number,
  featuredArticleId?: string,
  newsCategoryId?: string,
  type?: string,
  tag?: string,
) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/news/listing`, {
    params: {
      newsCategoryId,
      pageIndex,
      pageSize,
      type,
      featuredArticleId,
      tag,
    },
  });

  return data;
};
